<template>
	<div class="case-info">
		<ul class="card">
			<!-- <li>User: Test</li> -->
			<li class="case-list accent">Case: #{{ id }}</li>
			<li class="case-list">Pin: {{ caseData.pin }}</li>
			<li class="case-list">Address: {{ caseData.address }}, {{ caseData.municipality }}</li>
			<!-- <li class="case-list">Status: {{ statusById(caseData.orderStatus) }}</li> -->
		</ul>
	</div>
</template>

<script>
export default {
	name: "case-info",
	props: ["id"],
	data() {
		return {
			date: new Date(),
		};
	},
	computed: {
		caseData() {
			return this.$store.getters.getCaseData;
		},
	},
	methods: {
		statusById(id) {
			switch (id) {
				case "1":
					return "Order Pending";
					break;
				// case "2":
				// 	return "Not Paid";
				// 	break;
				case "2":
					return "Payment Submitted";
					break;
				// case "3":
				// 	return "Paid";
				// 	break;
				case "10":
					return "In Progress";
					break;
				case "50":
					return "Completed";
					break;
				// default:
				// 	return "Not Yet Opened";
				default:
					return "No Status";
			}
		},
	},
};
</script>

<style scoped lang="scss">
.case-info {
	.paragraph {
		margin-top: 30px;
		color: var(--white);
		opacity: 0.5;
	}
	.case-list {
		color: var(--dark-gray);
	}
	.case-list.accent {
		color: var(--accent);
	}
	ul {
		list-style-type: none;
		color: var(--white);
		padding-inline-start: unset;
		padding: 10px 20px;
	}
}
</style>
